import React from 'react';

const ProductCardFeatures = ({ features }) => {
  if (!features || features.length === 0) return null;

  return (
    <ul className='tw:mx-auto tw:mb-0 tw:mt-4 tw:max-w-[280px] tw:list-none tw:pl-0'>
      {features.map((feature) => (
        <li
          key={feature}
          className='tw:border-b tw:border-b-gray-dark tw:p-[10px] tw:text-center tw:text-sm tw:font-normal tw:text-gray-dark tw:last:border-b-0'
          dangerouslySetInnerHTML={{ __html: feature }}></li>
      ))}
    </ul>
  );
};

export default ProductCardFeatures;
